module.exports = __webpack_public_path__ + "img/arch.d511edb2.svg";